module.exports = __webpack_public_path__ + "media/styles/images/svg/project-charts-teal-b698ab98637cdd50706277eff117f416.svg";